import {dateTime} from "services/date";
import {Site} from "types/Site";
import deserializeZone from "services/ngage/deserializers/zone";
import {transformOpeningHours} from "../../opening-hours";

/**
 * Transform the given site by deserializing object properties
 *
 * @internal
 * @param site
 */
export default function deserializeSite(site: any): Site {
    site.created_at = dateTime(site.created_at)
    site.updated_at = dateTime(site.updated_at)

    if (site.zones){
        site.zones = site.zones.map(deserializeZone)
    }

    if (site.hours) {
        site.hours = transformOpeningHours(site.hours);
    }

    return site;
}